import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Windy = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path d="M25.2211 17.2937V16.7422C25.2211 14.0767 27.4271 11.8708 30.0926 11.8708C32.7581 11.8708 34.964 14.0767 34.964 16.7422C34.964 19.4078 32.7581 21.6137 30.0926 21.6137H5.09189M14.8967 13.3844V12.9886C14.8967 11.0092 16.5791 9.32681 18.5584 9.32681C20.5377 9.32681 22.2202 11.0092 22.2202 12.9886C22.2202 14.9679 20.5377 16.6503 18.5584 16.6503H5M5 25.1983H30.0926C31.9309 25.1983 33.4934 26.669 33.4934 28.5992C33.4934 30.5294 32.0228 32 30.0926 32C28.1624 32 26.6918 30.5294 26.6918 28.5992V28.2315" 
                stroke={props.color ? props.color : "white"}
                fill='white' 
                strokeWidth="2" 
                strokeLinecap="round"/>
        </SvgStyled>
    );
};

export default Windy;
